import { Order } from '@reliance/types/models/Commissary';
import {
    ORDER_LOADING, ORDER_LOAD_FAILED, ORDER_LOAD_SUCCESS
} from '../actions/commissary';

export interface ICommissaryOrderState {
  loading: boolean;
  order?: Order;
  error?: any;
}

const initialState: ICommissaryOrderState = {
  loading: false,
  order: null,
  error: null
};

export default function (
  state: ICommissaryOrderState = initialState,
  action
): ICommissaryOrderState {
  switch (action.type) {
    case ORDER_LOADING:
      return {
        ...state,
        loading: true,
        order: null,
        error: null
      };

    case ORDER_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        order: action.order,
        error: null
      };

    case ORDER_LOAD_FAILED:
      return {
        ...state,
        loading: false,
        order: null,
        error: action.error
      };
  }

  return state;
}
